import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';
import { getUserSyncURL, getCacheBuster } from './utils';

const ID = '46';
const IABid = [76];

export const createPixel = (): HTMLSpanElement => {
  const span = document.createElement('span');
  span.style.display = 'none';
  const redirect = getUserSyncURL(ID);
  span.innerHTML = `<iframe style="display:none" src="https://ads.pubmatic.com/AdServer/js/user_sync.html?r=${getCacheBuster()}&p=156007&predirect=${redirect}"></iframe>`;

  return span;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    const span = createPixel();
    fastdom.mutate(function userSyncPubmaticEmeaAddElement() {
      document.body.appendChild(span);
    });
  }),
);
